import { useEffect, useState } from 'react';

/**
 * Retarde la propagation d'une valeur qui change vite.
 *
 * Indispensable sur la recherche d'entreprises : sans lui, chaque frappe
 * déclencherait un appel à `GET /companies/search`, et l'API répondrait
 * rapidement `429 rate_limited` (la recherche a son propre quota, plus serré
 * que le reste de l'API).
 *
 * @param value  la valeur qui change à chaque frappe
 * @param delay  le silence à observer avant de la propager, en millisecondes
 */
export function useDebounce<T>(value: T, delay = 350): T {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delay);

        // Nettoyage : chaque nouvelle frappe annule le minuteur précédent.
        return () => clearTimeout(timer);
    }, [value, delay]);

    return debounced;
}
